// extracted by mini-css-extract-plugin
export default {"root":"classes_root__xaSnP","icon-container":"classes_icon-container__Jxzln","icon":"classes_icon__Y24kh"};